import { Accordion } from '@liveauctioneers/hammer-ui-core/accordion';
import { Menu } from '@liveauctioneers/hammer-ui-core/menu';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode } from 'react';

import { CurrentOpenMenu } from '@/pages/Search/SearchPage/types';

type Props = {
    accordionDefaultOpen?: boolean;
    children: ReactNode;
    className?: string;
    currentOpenMenu?: CurrentOpenMenu;
    currentOpenMenuId: CurrentOpenMenu;
    isAllFilters?: boolean;
    onMenuClose: () => void;
    onMenuOpen: (currentMenu: CurrentOpenMenu) => void;
    title?: string;
    trigger?: ReactNode;
};

export const ConditionalMenuContainer = ({
    accordionDefaultOpen,
    children,
    className,
    currentOpenMenu,
    currentOpenMenuId,
    isAllFilters,
    onMenuClose,
    onMenuOpen,
    title,
    trigger,
}: Props) => {
    if (isAllFilters) {
        return (
            <Accordion
                className="w-full"
                density="compact"
                emphasis="subtle"
                headline={title}
                open={accordionDefaultOpen}
            >
                <div className="flex flex-col gap-xs">{children}</div>
            </Accordion>
        );
    }

    return (
        <Menu
            defaultOpen={currentOpenMenu === currentOpenMenuId}
            hasRoundedBorders
            isCustomContent
            menuPlacement="bottom-start"
            numberOfColumns={1}
            onMenuClose={onMenuClose}
            onMenuOpen={() => onMenuOpen(currentOpenMenuId)}
            trigger={trigger}
        >
            <div
                className={cn(
                    'flex w-[300px] flex-col gap-xs px-sm py-xs',
                    { 'w-[400px]': currentOpenMenuId === CurrentOpenMenu.Location },
                    className
                )}
            >
                {title && <H5>{title}</H5>}
                {children}
            </div>
        </Menu>
    );
};
